import React, { useState, useEffect } from 'react';
import LeadCaptureForm from './LeadCaptureForm';

interface PopupTriggerProps {
  delay?: number; // Delay in milliseconds
  children?: React.ReactNode;
}

const PopupTrigger: React.FC<PopupTriggerProps> = ({ 
  delay = 30000, // 30 seconds default
  children 
}) => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Check if popup has been shown in this session
    const popupShown = sessionStorage.getItem('popupShown');
    
    if (!popupShown) {
      const timer = setTimeout(() => {
        setShowPopup(true);
        sessionStorage.setItem('popupShown', 'true');
      }, delay);

      return () => clearTimeout(timer);
    }
  }, [delay]);

  const handleClose = () => {
    setShowPopup(false);
  };

  const handleSubmit = (data: any) => {
    // Handle form submission
    console.log('Lead captured:', data);
    // Here you would typically send the data to your backend
  };

  return (
    <>
      {children}
      {showPopup && (
        <LeadCaptureForm
          type="popup"
          incentive="Get Your Free Quote + 10% Off Your First Project"
          onClose={handleClose}
          onSubmit={handleSubmit}
        />
      )}
    </>
  );
};

export default PopupTrigger; 